(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', '../seq/chain', 'lodash/concat', 'lodash/get', 'lodash/isEmpty', 'lodash/isObject'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('../seq/chain'), require('lodash/concat'), require('lodash/get'), require('lodash/isEmpty'), require('lodash/isObject'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.chain, global.concat, global.get, global.isEmpty, global.isObject);
    global.protect = mod.exports;
  }
})(this, function (exports, _chain, _concat, _get, _isEmpty, _isObject) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _chain2 = _interopRequireDefault(_chain);

  var _concat2 = _interopRequireDefault(_concat);

  var _get2 = _interopRequireDefault(_get);

  var _isEmpty2 = _interopRequireDefault(_isEmpty);

  var _isObject2 = _interopRequireDefault(_isObject);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  var ProtectHandler = function () {

    /**
     * Constructor.
     * @param {Object} chainWrapperRef The reference to the underlying ChainWrapper.
     * @param {Array} [path] The path of the proxy target.
     * @since 0.3.0
     */
    function ProtectHandler(chainWrapperRef) {
      var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

      _classCallCheck(this, ProtectHandler);

      this.chainWrapperRef = chainWrapperRef;
      this.path = path;
    }

    /**
     * Handle property access.
     * @param {*} target Target of the access.
     * @param {string} property Accessed property.
     * @return {*} Either the value of the property or a new Proxy.
     * @since 0.3.0
     */


    _createClass(ProtectHandler, [{
      key: 'get',
      value: function get(target, property) {
        var reference = this._peek()[property];
        if (!(0, _isObject2.default)(reference)) return reference;
        return new Proxy(reference, new ProtectHandler(this.chainWrapperRef, (0, _concat2.default)(this.path, property)));
      }
    }, {
      key: 'set',
      value: function set(target, property, value) {
        this.chainWrapperRef.chainWrapper = this.chainWrapperRef.chainWrapper.set((0, _concat2.default)(this.path, property), value);
        return true;
      }
    }, {
      key: 'deleteProperty',
      value: function deleteProperty(target, property) {
        this.chainWrapperRef.chainWrapper = this.chainWrapperRef.chainWrapper.unset((0, _concat2.default)(this.path, property));
        return true;
      }
    }, {
      key: '_peek',
      value: function _peek() {
        var peeked = void 0;
        this.chainWrapperRef.chainWrapper = this.chainWrapperRef.chainWrapper.peek(function (_peeked) {
          peeked = _peeked;
        });
        return (0, _isEmpty2.default)(this.path) ? peeked : (0, _get2.default)(peeked, this.path);
      }
    }]);

    return ProtectHandler;
  }();

  /**
   * 🚫 This is an experimental feature, do not use.<br />
   * Protect a reference, allowing to apply mutations on it, and then retrieve the result of the mutations.
   * @param {Object} reference Reference to protect.
   * @return {function} Function to be called with a callback accepting the protected reference, returning the result of the mutations performed by the callback.
   * @memberof util
   * @since 0.3.0
   * @example
   * protect({ a: 1, b: { c: 3 } })(protectedRef => {
   *   protectedRef.a++
   *   protectedRef.b.d = protectedRef.a * protectedRef.b.c
   *   delete protectedRef.b.c
   * }) // => { a: 2, b: { d: 6 } }
   */
  var protect = function protect(reference) {
    if (!(0, _isObject2.default)(reference)) throw TypeError('Cannot protect a non-object value');
    return function (callback) {
      var chainWrapper = (0, _chain2.default)(reference);
      var chainWrapperRef = { chainWrapper: chainWrapper };
      var proxy = new Proxy(reference, new ProtectHandler(chainWrapperRef));
      callback(proxy);
      return chainWrapperRef.chainWrapper.value();
    };
  };

  exports.default = protect;
});